import { AxiosError } from 'axios';
import { StatusCodes } from 'http-status-codes';

export const getApiErrorData = <T>(error: AxiosError<T> | undefined) => error?.response?.data;

export const getApiErrorStatusCode = (error: AxiosError | undefined): StatusCodes | undefined =>
  error?.response?.status;
